module.exports = __webpack_public_path__ + "static/media/dz.44d35712.svg";